import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useParams } from "react-router-dom";
import logoBraspag from "assets/images/logo.svg";
import Alert from '@mui/material/Alert';

function Basic() {
    let { errorCode } = useParams();

    return (
        <>
            <BasicLayout>
                <Grid container spacing={3} p={4}>
                    <Grid item xs={12} md={12}>
                        <MDBox component="img" src={logoBraspag} alt="Brand" width="8rem" fullwidth="true" />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Alert severity="error" variant="outlined">
                            Ocorreu um erro na instalação, informe o código abaixo para o suporte.<br />
                            {errorCode}
                        </Alert>
                    </Grid>
                </Grid>
            </BasicLayout >
        </>
    );
}

export default Basic;
